import React from 'react';
import { motion } from 'framer-motion';
import { FaFileContract, FaShieldAlt, FaExclamationTriangle, FaInfoCircle, FaGlobe, FaLink, FaSyncAlt, FaPhoneAlt } from 'react-icons/fa';
const sections = [
  {
    icon: <FaFileContract />,
    title: '१. अटींची स्वीकृती',
    content: 'या संकेतस्थळावर प्रवेश करून, वापरकर्ते या अटी व शर्तींमध्ये नमूद केलेल्या नियमांचे पालन करण्यास सहमत आहेत. जर आपण या अटींशी सहमत नसाल, तर कृपया संकेतस्थळाचा वापर करू नये.'
  },
  {
    icon: <FaInfoCircle />,
    title: '२. संकेतस्थळाचा उद्देश',
    content: 'हे संकेतस्थळ खालील माहिती प्रदान करण्यासाठी विकसित केले आहे: ग्रामपंचायत सेवा, शासकीय योजना, गाव विकास उपक्रम, सार्वजनिक सूचना व घोषणा, ग्रामपंचायतच्या संपर्क माहिती.'
  },
  {
    icon: <FaShieldAlt />,
    title: '३. माहितीची अचूकता',
    content: 'ग्रामपंचायत नाशेरा या संकेतस्थळावर दिलेली माहिती अचूक व अद्ययावत असावी यासाठी सर्वतोपरी प्रयत्न करते. तथापि, माहितीची पूर्णता किंवा विश्वासार्हतेची हमी दिली जात नाही.'
  },
  {
    icon: <FaExclamationTriangle />,
    title: '४. संकेतस्थळाचा वापर',
    content: 'वापरकर्ते केवळ कायदेशीर उद्देशांसाठी संकेतस्थळाचा वापर करण्यास सहमत आहेत. कोणताही गैरवापर, हॅकिंगचा प्रयत्न किंवा अनधिकृत प्रवेश कठोरपणे प्रतिबंधित आहे.'
  },
  {
    icon: <FaGlobe />,
    title: '५. बौद्धिक संपदा',
    content: 'या संकेतस्थळावरील सर्व मजकूर, प्रतिमा, लोगो आणि दस्तऐवज ग्रामपंचायत नाशेराच्या मालकीचे आहेत. अनधिकृत वापर किंवा पुनरुत्पादन परवानगी नाही.'
  },
  {
    icon: <FaLink />,
    title: '६. बाह्य दुवे',
    content: 'या संकेतस्थळावर बाह्य शासकीय संकेतस्थळांचे दुवे असू शकतात. त्या बाह्य साइट्सच्या सामग्री किंवा धोरणांसाठी ग्रामपंचायत नाशेरा जबाबदार नाही.'
  },
  {
    icon: <FaSyncAlt />,
    title: '७. अटींमध्ये बदल',
    content: 'ग्रामपंचायत नाशेरा पूर्वसूचनेशिवाय कधीही या अटी व शर्ती अद्यतनित किंवा सुधारित करण्याचा अधिकार राखून ठेवते.'
  },
  {
    icon: <FaPhoneAlt />,
    title: '८. संपर्क माहिती',
    content: 'या अटी व शर्तींबाबत काही प्रश्न असल्यास संपर्क करा: ग्रामपंचायत नाशेरा, तालुका: मोखाडा | जिल्हा: पालघर, महाराष्ट्र - ४०१६०४. ईमेल: gpnasherapsmokhada@gmail.com | फोन: +91 7620 135 257'
  }
];

function Terms({ language }) {
  return (
    <div style={{ marginTop: '80px' }}>
      {/* Hero Section */}
      <motion.section
        className="hero"
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <motion.h1
            className="page-hero-title"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            अटी व शर्ती
          </motion.h1>
          <motion.p
            className="page-hero-sub"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            ग्रामपंचायत नाशेरा — संकेतस्थळ वापराच्या अटी
          </motion.p>
        </div>
      </motion.section>

      <section className="services-section">
        <div className="container">
          {/* Intro banner */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #138808 0%, #2e7d32 100%)',
              color: 'white',
              padding: '2rem 2.5rem',
              borderRadius: '15px',
              textAlign: 'center',
              marginBottom: '3rem',
              boxShadow: '0 10px 30px rgba(19,136,8,0.25)'
            }}
          >
            <h2 style={{ marginBottom: '0.8rem', fontSize: '1.6rem', fontWeight: 700 }}>
              ग्रामपंचायत नाशेराच्या अधिकृत संकेतस्थळावर आपले स्वागत आहे
            </h2>
            <p style={{ fontSize: '1.05rem', lineHeight: '1.7', opacity: 0.92 }}>
              या संकेतस्थळावर प्रवेश करून व वापर करून, आपण खालील अटी व शर्तींचे पालन करण्यास सहमत आहात.
            </p>
          </motion.div>

          {/* Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1.5rem',
            marginBottom: '2rem'
          }}>
            {sections.map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.07 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.13)' }}
                style={{
                  background: 'white',
                  borderRadius: '12px',
                  borderLeft: '4px solid #138808',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  padding: '1.5rem',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                  transition: 'all 0.3s ease'
                }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {section.icon}
                </div>
                <div>
                  <h4 style={{ color: '#2c3e50', fontWeight: '700', fontSize: '1rem', marginBottom: '0.5rem' }}>
                    {section.title}
                  </h4>
                  <p style={{ color: '#555', fontSize: '0.92rem', lineHeight: '1.7', margin: 0 }}>
                    {section.content}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Footer note */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            style={{
              background: 'linear-gradient(135deg, #1a3a2a, #0f2027)',
              color: 'white',
              padding: '1.8rem 2rem',
              borderRadius: '12px',
              textAlign: 'center',
              marginTop: '1rem'
            }}
          >
            <p style={{ fontSize: '1rem', margin: 0, opacity: 0.9, lineHeight: 1.7 }}>
              या अटी प्रकाशन तारखेपासून लागू आहेत आणि पूर्वसूचनेशिवाय अद्यतनित केल्या जाऊ शकतात.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Terms;
